import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import BackToTop from '../components/BackToTop';

/* Lightweight placeholder for About sub-pages (Company, Partner With Us, Social Responsibility,
   Modern Slavery, Press & Media). Final copy/imagery will be supplied by the business.
   Uses the brand glass hero to stay visually consistent with other sub-pages. */

const HERO_BG = 'https://customer-assets.emergentagent.com/job_3f9e40e3-cca9-4507-83e7-20ced098354a/artifacts/69qn1rnj_ABSTRACT%20DESIGN.png';

const AboutPlaceholder = ({ eyebrow = 'About eCOMM', title, subtitle, testId }) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col" data-testid={testId}>
      <Header />
      <div className="h-20" />

      <section
        className="relative bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${HERO_BG})` }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-[#0a1929]/92 via-[#0a1929]/82 to-[#163a5f]/88" />
        <div className="relative z-10 max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-14">
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-2 text-white/85 hover:text-white font-medium mb-8 transition-colors duration-200"
            data-testid={`${testId}-back`}
          >
            <ArrowLeft size={18} />
            Back to Home
          </button>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#ef5b25]/20 border border-[#ef5b25]/40 text-[#ffcba6] text-[11px] font-bold uppercase tracking-[0.15em] mb-5">
            {eyebrow}
          </div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-5 leading-tight">
            {title}
          </h1>
          {subtitle && (
            <p className="text-lg sm:text-xl text-white font-semibold leading-relaxed max-w-3xl">
              {subtitle}
            </p>
          )}
        </div>
      </section>

      <section className="flex-1 bg-gradient-to-b from-gray-50 to-white py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-lg shadow-md border border-gray-100 p-8 sm:p-12 text-center">
            <p className="text-sm font-bold text-[#1F4E79] uppercase tracking-[0.15em] mb-3">Coming Soon</p>
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">
              This page is being prepared
            </h2>
            <p className="text-gray-600 text-base leading-relaxed max-w-2xl mx-auto">
              We're finalising the content for <strong>{title}</strong>. Please check back shortly — in the meantime, feel free to explore our products or get in touch via the Contact page.
            </p>
          </div>
        </div>
      </section>

      <Footer />
      <BackToTop />
    </div>
  );
};

export default AboutPlaceholder;
